import { render, staticRenderFns } from "./AccidentView.vue?vue&type=template&id=9c6ffd00&scoped=true"
import script from "./AccidentView.vue?vue&type=script&lang=js"
export * from "./AccidentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6ffd00",
  null
  
)

export default component.exports